import React, { useState, useEffect } from 'react';
import { Button } from 'react-md';
import { useDispatch } from 'react-redux';
import { push } from 'connected-react-router';
import { useParams } from 'react-router-dom';
import { Icon } from 'antd';
import { getActivePromotionBanner, trackBannerClick } from '../../../api/dashboardAPI';

const PromotionsBanner = () => {
    const dispatch = useDispatch();
    const { country } = useParams();
    const [bannerData, setBannerData] = useState(null);
    const [isVisible, setIsVisible] = useState(true);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchBanner = async () => {
            const data = await getActivePromotionBanner();
            if (data && data.id) {
                setBannerData(data);
                setIsVisible(true);
            } else {
                setIsVisible(false);
            }
            setLoading(false);
        };
        fetchBanner();
    }, []);

    if (loading || !isVisible || !bannerData) return null;

    const handleClick = () => {
        // Track the click
        if (bannerData && bannerData.id) {
            trackBannerClick(bannerData.id);
        }

        const target = bannerData.targetUrl || `/${country}/dashboard/promotions`;
        if (target.startsWith('http')) {
            window.open(target, '_blank');
        } else {
            dispatch(push(target));
        }
    };

    const handleDismiss = (e) => {
        e.stopPropagation();
        setIsVisible(false);
    };

    const getIcon = (iconName, color) => {
        const style = { color: color || 'inherit' };
        switch (iconName) {
            case 'RocketOutlined': return <Icon type="rocket" theme="filled" className="banner-icon" style={style} />;
            case 'StarOutlined': return <Icon type="star" theme="filled" className="banner-icon" style={style} />;
            case 'NotificationOutlined': return <Icon type="notification" theme="filled" className="banner-icon" style={style} />;
            case 'SoundOutlined': return <Icon type="sound" theme="filled" className="banner-icon" style={style} />;
            case 'GiftOutlined': return <Icon type="gift" theme="filled" className="banner-icon" style={style} />;
            case 'FireOutlined': return <Icon type="fire" theme="filled" className="banner-icon" style={style} />;
            default: return <Icon type="rocket" theme="filled" className="banner-icon" style={style} />;
        }
    };

    const bannerStyle = {
        backgroundColor: bannerData.useGradient ? undefined : bannerData.backgroundColor,
        backgroundImage: bannerData.useGradient
            ? `linear-gradient(135deg, ${bannerData.backgroundColor} 0%, rgba(255,255,255,0.15) 100%)`
            : undefined,
        color: bannerData.textColor,
        cursor: 'pointer'
    };

    const btnStyle = {
        backgroundColor: bannerData.buttonColor,
        color: bannerData.buttonTextColor || bannerData.backgroundColor
    };

    return (
        <div
            className={`promotions-banner-wrapper ${bannerData.showAnimation ? 'show-animation' : ''}`}
            onClick={handleClick}
            style={bannerStyle}
        >
            <div className="banner-content">
                <div className="banner-icon-container">
                    {getIcon(bannerData.icon, bannerData.textColor)}
                </div>
                <div className="banner-text-content">
                    <div className="banner-text" style={{ color: bannerData.textColor }}>
                        {bannerData.text}
                    </div>
                    {bannerData.subText && (
                        <div className="banner-subtext" style={{ fontSize: '12px', opacity: 0.9 }}>
                            {bannerData.subText}
                        </div>
                    )}
                </div>
            </div>
            <div className="banner-actions">
                <Button
                    flat
                    className="banner-btn"
                    style={btnStyle}
                >
                    {bannerData.buttonText || 'Get Started'}
                </Button>
                <button
                    className="dismiss-btn"
                    onClick={handleDismiss}
                    title="Dismiss"
                    style={{ color: bannerData.textColor }}
                >
                    <Icon type="close" />
                </button>
            </div>
        </div>
    );
};

export default PromotionsBanner;
